import TechnicalDataButton from './TechnicalDataButton'
import technicalDataButtonContainer from './technicalDataButtonContainer'

export default technicalDataButtonContainer(TechnicalDataButton) 